import { Record } from 'immutable';
import {
  AUTH_CREATE_STUDENT_RECORD_SUCCESS,
  AUTH_LOAD_STUDENT_RECORD_SUCCESS,
  INIT_AUTH,
  SIGN_IN_SUCCESS,
  SIGN_OUT_SUCCESS } from './action-types';


export const AuthState = new Record({
  allocationBatchNumber: null,
  authenticated: false,
  classYear: null,
  firstName: null,
  lastName: null,
  preferredFirstName: null,
  email: null,
  gender: null,
  id: null,
  individualLotteryNumber: null,
  isGroupLeader: false,
  isInPendingGroup: false,
  isInConfirmedGroup: false,
  isOnCampus: null,
  gradeLevel: null,
  groupId: null,
  groupLotteryNumber: null,
  key: null,
  number: null,
  existsInFirebase: false
});


//=============================
// Right now email is inject into state from providerData[0].
// This will change when the auth method changes.
//=============================
export function authReducer(state = new AuthState(), {payload, type}) {
  switch (type) {
    case INIT_AUTH:
    case SIGN_IN_SUCCESS:
      return state.merge({
        authenticated: !!payload,
        id: payload ? payload.uid : null,
        email: payload ? payload.email : null
      });

    case AUTH_LOAD_STUDENT_RECORD_SUCCESS:
      return state.merge({
        allocationBatchNumber: payload ? (payload.allocationBatchNumber ? payload.allocationBatchNumber : null) : null,
        classYear: payload ? (payload.classYear ? payload.classYear : null) : null,
        firstName: payload ? (payload.firstName ? payload.firstName : null) : null,
        lastName: payload ? (payload.lastName ? payload.lastName : null) : null,
        preferredFirstName: payload ? (payload.preferredFirstName ? payload.preferredFirstName : null) : null,
        gender: payload ? (payload.gender ? payload.gender : null) : null,
        individualLotteryNumber: payload ? (payload.individualLotteryNumber ? payload.individualLotteryNumber : null) : null,
        isGroupLeader: payload ? payload.isGroupLeader : null,
        isInPendingGroup: payload ? payload.isInPendingGroup : null,
        isInConfirmedGroup: payload ? payload.isInConfirmedGroup : null,
        isOnCampus: payload ? payload.isOnCampus : null,
        gradeLevel: payload ? (payload.gradeLevel ? payload.gradeLevel : null) : null,
        groupId: payload ? (payload.groupId ? payload.groupId : null) : null,
        groupLotteryNumber: payload ? (payload.groupLotteryNumber ? payload.groupLotteryNumber : null) : null,
        key: payload ? (payload.key ? payload.key : null) : null,
        number: payload ? (payload.number ? payload.number : (payload.number === 0 ? payload.number : null) ) : null,
        existsInFirebase: payload ? true : false
      })

    case AUTH_CREATE_STUDENT_RECORD_SUCCESS:
      return state.merge({
        allocationBatchNumber: payload ? (payload.allocationBatchNumber ? payload.allocationBatchNumber : null) : null,
        classYear: payload ? (payload.classYear ? payload.classYear : null) : null,
        firstName: payload ? (payload.firstName ? payload.firstName : null) : null,
        lastName: payload ? (payload.lastName ? payload.lastName : null) : null,
        preferredFirstName: payload ? (payload.preferredFirstName ? payload.preferredFirstName : null) : null,
        gender: payload ? (payload.gender ? payload.gender : null) : null,
        individualLotteryNumber: payload ? (payload.individualLotteryNumber ? payload.individualLotteryNumber : null) : null,
        isGroupLeader: payload ? payload.isGroupLeader : null,
        isInPendingGroup: payload ? payload.isInPendingGroup : null,
        isInConfirmedGroup: payload ? payload.isInConfirmedGroup : null,
        isOnCampus: payload ? payload.isOnCampus : null,
        gradeLevel: payload ? (payload.gradeLevel ? payload.gradeLevel : null) : null,
        groupId: payload ? (payload.groupId ? payload.groupId : null) : null,
        groupLotteryNumber: payload ? (payload.groupLotteryNumber ? payload.groupLotteryNumber : null) : null,
        key: payload ? (payload.key ? payload.key : null) : null,
        number: payload ? (payload.number ? payload.number : null) : null,
        existsInFirebase: payload ? true : false
      })

    case SIGN_OUT_SUCCESS:
      return new AuthState();

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/core/auth/reducer.js